import { render, staticRenderFns } from "./SiteDetail.vue?vue&type=template&id=3c9ca65e&scoped=true&"
import script from "./SiteDetail.vue?vue&type=script&lang=ts&"
export * from "./SiteDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SiteDetail.vue?vue&type=style&index=0&id=3c9ca65e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ca65e",
  null
  
)

export default component.exports